<template>
  <div
    class="header-seo-links">
    <div class="container header-seo-links__container">
      <nav class="header-seo-links__content anti-content">
        <ul class="header-seo-links__list">
          <li
            v-for="link in links"
            :key="link.order"
            class="header-seo-links__item">
            <a
              :href="link.link"
              class="header-seo-links__link transition--color"
              target="_blank"
              rel="noopener">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainHeaderSeoLinks',

  props: {
    links: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .header-seo-links {
    background-color: $color--basic-menu;
  }

  .header-seo-links__container {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .header-seo-links__list {
    display:flex;
    align-items: center;
  }

  .header-seo-links__item {
    text-align: center;

    &:not(:first-child) {
      margin-left: 24px;
    }
  }

  .header-seo-links__link {
    font-size: $text-11px;
    line-height: 1.2;
    font-weight: 500;
    color: $color--basic-light-gray;
  }

  @media only screen and #{$screen-less-than-1024} {
    .header-seo-links__content {
      padding: 0;
    }

    .header-seo-links__list {
      @include scroll-snap-parent;

      overflow-x: scroll;
      overflow-y: hidden;
      scroll-padding-left: var(--padding);
      padding-left: var(--padding);
      padding-right: var(--padding);
    }

    .header-seo-links__item {
      width: 97px;
      flex-shrink: 0;
      scroll-snap-align: start;

      &:not(:first-child) {
        margin-left: 16px;
      }
    }
  }

  @media only screen and #{$screen-more-or-1024} {
    .header-seo-links__container {
      padding-top: 15px;
      padding-bottom: 19px;
    }

    .header-seo-links__item {
      max-width: 230px;
      flex: 1;
    }

    .header-seo-links__link {
      font-size: $text-13px;
    }
  }

  @media #{$device--mouse} {
    .header-seo-links__link:hover {
      color: $color--basic-white;
    }
  }

</style>
